module.exports = __webpack_public_path__ + "print&share.png?c73abed0744ee4f2113c160346a3832e";


//////////////////
// WEBPACK FOOTER
// ./static/images/print&share.png
// module id = 27
// module chunks = 0 1